webpackJsonp([85682538701299],{

/***/ 380:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Dominik Schwarz","subtitle":"My personal website to share projects and maybe some thoughts.","copyright":"© Dominik Schwarz. All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"}],"author":{"name":"Dominik Schwarz","email":"contact@domsch.me","twitter":"DomSch94","github":"durac"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/hello-world/","categorySlug":"/categories/hello/"},"frontmatter":{"title":"Hello World!","date":"2018-10-21T17:20:37.121Z","category":"Hello","description":"My first-ever blog post! And Hopefully not the last."}}}]}},"pathContext":{"category":"Hello"}}

/***/ })

});


// WEBPACK FOOTER //
// path---categories-hello-878b432c05eedfbf3391.js